module.exports = __webpack_public_path__ + "img/TipperRoof-Repairing.2d91e0d8.jpg";